import useEmbeddedBuild from './use-embedded-build';

export default useEmbeddedBuild;
